import { server_connection } from 'config';
import { setUserData } from '../../../../../auth/store/actions';
import history from 'history.js';
export const UPDATE_PROFILE_LOADED = '[DASHBOARD APP] UPDATE PROFILE LOADED';
export const UPLOAD_AVATAR         = '[DASHBOARD APP] UPLOAD AVATAR';

export function updateProfileLoaded(setting) {
    return {
        type: UPDATE_PROFILE_LOADED,
        payload: setting
    }
}

export function uploadAvatar(formData) {
    return (dispatch, getState) => {
        fetch(server_connection + '/asset/upload/avatar',
        {
            method: 'POST',
            body: formData
        })
        .then((responseData) => {
            window.location.reload()
        });
    } 
}

export function toggleActiveAuthRole(auth_id, role_id, link_id, company_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/auth/toggle_active_role',
        {
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({ auth_id, role_id, link_id, company_id })
        })
        .then((response) => response.json())
        .then((responseData) => {
            dispatch(setUserData(responseData))
            window.location.reload()
        })
    }
}

export function verifyUserPassword(auth_id, newPassword) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/auth/verify_password',
        {
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({ auth_id, newPassword })
        })
        .then((response) => response.json())
        .then((responseData) => {
            dispatch(setUserData(responseData))
        })
    }
}


// WEBPACK FOOTER //
// src/main/content/dashboard/store/actions/profile.actions.js